import { render, staticRenderFns } from "./v-slide.vue?vue&type=template&id=84058772&"
import script from "./v-slide.vue?vue&type=script&lang=js&"
export * from "./v-slide.vue?vue&type=script&lang=js&"
import style0 from "./v-slide.vue?vue&type=style&index=0&id=84058772&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports